import MovimentacaoConsolidadoPessoa from "@/Models/Domain/FInanceiro/Relatorio/MovimentacaoConsolidadaPessoa";
import Pagina, { IPagina, IPaginaInfo } from "@/Models/Utils/Pagina/Pagina";
import { Axios } from "@/Services/Axios";
import RequestUtilitario, { QueryBasicaParam } from "@/Utils/RequisicaoUtilitario";
import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { Dayjs } from "dayjs";

export function useMovimentacaoConsilidadoPessoaListar({
    pagina,
    codPessoa,
    intervalo,
    codigosPessoas,
    codigosCentroCusto,
    codigosPlanoContas,
    onFinish,
    ...rest
}:QueryBasicaParam<AxiosResponse<IPagina<MovimentacaoConsolidadoPessoa>>, IPagina<MovimentacaoConsolidadoPessoa>, {
    pagina?:IPaginaInfo;
    codPessoa?:number;
    intervalo?:[Dayjs|undefined|Date, Dayjs|undefined|Date];
    codigosPessoas?:Array<number>;
    codigosCentroCusto?:Array<number>;
    codigosPlanoContas?:Array<number>;
    onFinish?:() => void;
}>) {
    const queryString = RequestUtilitario.objectToQueryString({
        pagina,
        dataInical : intervalo?.[0] === undefined ? null : new Date(intervalo?.[0].valueOf()),
        dataFinal : intervalo?.[1] === undefined ? null : new Date(intervalo?.[1].valueOf()),
        codigosPessoas,
        codigosCentroCusto,
        codigosPlanoContas
    });

    return useQuery({
        ...rest,
        queryKey : ["Domain", "Relatorio", "MovimentacaoConsolidadoPessoa", codPessoa, queryString],
        queryFn : () => Axios.get<IPagina<MovimentacaoConsolidadoPessoa>>(`domain/relatorio/MovimentacaoConsolidadaPessoa?codPessoa=${codPessoa}&${queryString}`).finally(onFinish),
        select(data) { 
            const pagina = data.data;

            pagina.registros = pagina.registros.map(m => {
                m.movimentacoes = m.movimentacoes.map(mm => {
                    mm.dataMovimentacao = new Date(mm.dataMovimentacao as any);
                    mm.dataCriacao = new Date(mm.dataCriacao as any);
                    if (mm.titulo != null) {
                        mm.titulo.dataCredito = new Date(mm.titulo?.dataCredito as any);
                        mm.titulo.dataVencimento = new Date(mm.titulo?.dataVencimento as any);
                    }
                    return mm;
                });
                return m;
            });

            return pagina;
        },
        staleTime : 1000 * 60 * 0.5
    });
}